import React from 'react';
import ProjectCards from './Projectcards';
import './Projectcards.css';
import CustomButton from './Custombtn';
 
const projectData1 = {
  projectName: 'VogueFlair: Unveiling Fashion Application',
  projectYear: 'Jun 2022 - Aug 2022',
  universityName: 'Associated with OP Jindal University',
  projectDescription: 'Experience the epitome of fashion discovery with VogueFlair, a Java powered fashion shopping application that seamlessly marries technology and style.',
  skills: 'MySQL , Java Swing , Java Libraries , DSA , Java'
};

const projectData2 = {
  projectName: 'Netwatch: Video Streamer Website',
  projectYear: 'Mar 2023 - May 2023',
  universityName: 'Associated with OP Jindal University',
  projectDescription: 'Designed and developed a robust video streaming website from scratch, offering seamless content delivery and relevant suggestions.',
  skills: 'JSON · HTML5 · JavaScript · Cascading Style Sheets (CSS)',
  href:"https://netwatch25.netlify.app/"
};

const projectData3 = {
  projectName: 'ProCareerHub: Job Search Website',
  projectYear: 'May 2023 - Jul 2023',
  universityName: 'Associated with OP Jindal University',
  projectDescription: 'Developed a user-friendly job search website connecting job seekers with relevant opportunities and aiding employers in recruitment.',
  skills: 'HTML5 · JavaScript · Cascading Style Sheets (CSS)',
  href:"https://harshagrawaljobsite.netlify.app/"
}


function Projects() {
  return (
    <div className='Projectcontainer'>
      <h1 className='Pagetitle'>Projects</h1>
      <div className='carddetails'>
       <ProjectCards {...projectData1}/>
       <ProjectCards {...projectData2}/>
       <ProjectCards {...projectData3}/>
      </div>
      <div className='allprojects'>
      <CustomButton btntitle="View all Projects" href="https://www.linkedin.com/in/harshagrawal2503/details/projects/"/>
      </div>
    </div>
  );
}

export default Projects;
